import { createSelector } from '@reduxjs/toolkit';
import {
    selectTranslatedEntityIdsDirectionMaps,
} from '~SpectateStore/selectors/translatedEntityIdsSliceSelectors';

const pickTranslatedIds = (ids, translatedIdMap) => ids.reduce((subset, id) => {
    const translatedId = translatedIdMap[id];
    if (translatedId) {
        subset[id] = translatedId;
    }

    return subset;
}, {});

const isIdMissing = (id, translatedIdMap, inFlightMap) =>
    translatedIdMap[id] === undefined && !inFlightMap[id];

const selectDirectionMaps = (state, { from, to }) => selectTranslatedEntityIdsDirectionMaps(state, from, to);
const selectRequestedEvents = (_state, { events = [] }) => events;
const selectRequestedSelections = (_state, { selections = [] }) => selections;

export const selectTranslatedEntityIds = createSelector(
    [
        selectDirectionMaps,
        selectRequestedEvents,
        selectRequestedSelections,
    ],
    (directionMaps, events, selections) => ({
        events: pickTranslatedIds(events, directionMaps.events),
        selections: pickTranslatedIds(selections, directionMaps.selections),
    }),
);

export const selectAreEntityIdsFetching = createSelector(
    [
        selectDirectionMaps,
        selectRequestedEvents,
        selectRequestedSelections,
    ],
    (directionMaps, events, selections) => {
        const enabled = events.length > 0 || selections.length > 0;
        if (!enabled) {

            return true;
        }

        const isPending = events.some(id => directionMaps.inFlight.events[id])
            || selections.some(id => directionMaps.inFlight.selections[id]);
        if (isPending) {

            return true;
        }

        const isResolved = events.every(id => directionMaps.events[id] !== undefined)
            && selections.every(id => directionMaps.selections[id] !== undefined);

        return !isResolved;
    },
);

export const selectMissingEntityIds = createSelector(
    [
        selectDirectionMaps,
        selectRequestedEvents,
        selectRequestedSelections,
    ],
    (directionMaps, events, selections) => ({
        events: events.filter(id => isIdMissing(id, directionMaps.events, directionMaps.inFlight.events)),
        selections: selections.filter(id => isIdMissing(id, directionMaps.selections, directionMaps.inFlight.selections)),
    }),
);
